import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { USER_addres } from '../../API/API';

/**
 * Страница на которую Яндекс редиректит после авторизации.
 * URL: /auth/yandex/callback?code=...&state=...
 *
 * Только login-mode (verify/email-confirm не нужен для робототехники).
 */
const YandexCallback = () => {
    const navigate = useNavigate();
    const { login: authLogin } = useAuth();
    const [error, setError] = useState('');
    const [step, setStep] = useState('Подключаемся к Яндексу...');
    // Guard от двойного вызова exchange в React StrictMode.
    // state одноразовый — второй вызов вернёт 400 «state истёк».
    const exchangedRef = useRef(false);

    useEffect(() => {
        if (exchangedRef.current) return;
        exchangedRef.current = true;

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const yandexError = params.get('error');

        if (yandexError) {
            setError('Яндекс отменил вход: ' + yandexError);
            return;
        }
        if (!code || !state) {
            setError('Неполные данные от Яндекса');
            return;
        }

        (async () => {
            try {
                setStep('Получаем ваш профиль...');
                const r = await fetch(`${USER_addres}/api/v1/users/auth/yandex/exchange`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code, state }),
                });
                const data = await r.json();
                if (!r.ok || !data.token) {
                    setError(data.message || 'Не удалось завершить вход');
                    return;
                }
                // ВАЖНО: кладём токен ДО любых API-запросов вручную —
                // иначе axios-interceptor / AuthContext.init может схватить 401
                // и удалить токен (гонка после загрузки SPA на /auth/yandex/callback).
                localStorage.setItem('Authorization', data.token);
                if (data.refreshToken) {
                    localStorage.setItem('refreshToken', data.refreshToken);
                }
                authLogin(data.token);
                setStep('Заходим в кабинет...');
                // Жёсткий редирект через window.location — SPA загрузится с уже
                // установленным токеном, AuthContext.init спокойно проверит
                // авторизацию и пустит в защищённую зону /main.
                setTimeout(() => { window.location.replace('/main'); }, 200);
            } catch (e) {
                setError('Сеть недоступна, попробуйте ещё раз');
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#0a0e1a',
            color: '#fff',
            fontFamily: "'Exo 2', system-ui, sans-serif",
            padding: 20,
        }}>
            <div style={{
                maxWidth: 420,
                width: '100%',
                background: '#10131a',
                border: '1px solid #1f2937',
                borderRadius: 16,
                padding: 32,
                textAlign: 'center',
            }}>
                {error ? (
                    <>
                        <div style={{
                            width: 64, height: 64,
                            borderRadius: '50%',
                            background: '#fee2e2',
                            color: '#dc2626',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 16px',
                            fontSize: 32,
                        }}>!</div>
                        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Не удалось войти</h2>
                        <p style={{ color: '#94a3b8', marginBottom: 20 }}>{error}</p>
                        <button
                            onClick={() => navigate('/login')}
                            style={{
                                padding: '10px 20px',
                                background: '#3b82f6',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 8,
                                cursor: 'pointer',
                                fontSize: 14,
                            }}
                        >В настройки</button>
                    </>
                ) : (
                    <>
                        <div style={{
                            width: 48, height: 48,
                            border: '4px solid #1f2937',
                            borderTopColor: '#FC3F1D',
                            borderRadius: '50%',
                            margin: '0 auto 16px',
                            animation: 'spin 1s linear infinite',
                        }} />
                        <h2 style={{ fontSize: 18, marginBottom: 8 }}>Вход через Яндекс</h2>
                        <p style={{ color: '#94a3b8' }}>{step}</p>
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </>
                )}
            </div>
        </div>
    );
};

export default YandexCallback;
